/**
 * @generated SignedSource<<cab021137e612967d4f75ba3604acdd9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Ordering = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type SchoolTypeEnum = "elementary_school" | "high_school" | "middle_school" | "%future added value";
export type UnitAFilter = {
  AND?: UnitAFilter | null;
  DISTINCT?: boolean | null;
  NOT?: UnitAFilter | null;
  OR?: UnitAFilter | null;
  courseId_Exact?: string | null;
  courseId_In?: ReadonlyArray<string> | null;
  courseTitle_Contains?: string | null;
  id?: string | null;
  id_Exact?: string | null;
  id_In?: ReadonlyArray<string> | null;
  id_Not_In?: ReadonlyArray<string> | null;
  problemGenerator_Exists?: boolean | null;
  search?: string | null;
  title_Contains?: string | null;
  title_Exact?: string | null;
  title_In?: ReadonlyArray<string> | null;
  unitId_Exact?: string | null;
  unitId_In?: ReadonlyArray<string> | null;
  unitSchoolType_Exact?: SchoolTypeEnum | null;
  unitSchoolType_In?: ReadonlyArray<SchoolTypeEnum> | null;
  unitTitle_Contains?: string | null;
};
export type UnitAOrder = {
  id?: Ordering | null;
  order?: Ordering | null;
  schoolType?: Ordering | null;
  title?: Ordering | null;
};
export type UnitDSelectDialogField_unitAsQuery$variables = {
  filters?: UnitAFilter | null;
  order?: UnitAOrder | null;
};
export type UnitDSelectDialogField_unitAsQuery$data = {
  readonly unitAs: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      };
    }>;
  };
};
export type UnitDSelectDialogField_unitAsQuery = {
  response: UnitDSelectDialogField_unitAsQuery$data;
  variables: UnitDSelectDialogField_unitAsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      },
      {
        "kind": "Variable",
        "name": "order",
        "variableName": "order"
      }
    ],
    "concreteType": "UnitAConnection",
    "kind": "LinkedField",
    "name": "unitAs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnitAEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnitA",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnitDSelectDialogField_unitAsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnitDSelectDialogField_unitAsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bcb16de77ed8b92763b53fd4945fe21e",
    "id": null,
    "metadata": {},
    "name": "UnitDSelectDialogField_unitAsQuery",
    "operationKind": "query",
    "text": "query UnitDSelectDialogField_unitAsQuery(\n  $filters: UnitAFilter\n  $order: UnitAOrder\n) {\n  unitAs(filters: $filters, order: $order, first: 1) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b39a2d5193c4381ea359c50859e97c7e";

export default node;
